<template>
<div class="GoodsEdit form" v-show="init">
    <el-form :model="item" :rules="rules" ref="ruleForm" label-width="135px" class="demo-item">
        <div class="activityMsgBox">
            <div class="title"><p>商品信息</p></div>
            <div class="contentBox">
                <div class="left">
                    <el-form-item label="商品名称" prop="productname">
                        <el-input v-model="item.productname " maxlength="40" show-word-limit :disabled="param.isview"
                                  placeholder="输入商品名称，不超过40个字"></el-input>
                    </el-form-item>
                    <el-form-item label="商品主图" class="cover isRequired" prop="logoatturlid">
                        <div class="imgBox">
                            <i class="el-icon-picture" v-if="!item.logoatturlid "></i>
                            <img class="activityCoverImage" :src="item.logoatturlid  + '?' + time"
                                 v-else-if="item && item.logoatturlid  + '?' + time"
                                 alt="">
                        </div>
                        <div class="uploadFileBox">
                            <el-button @click.native="openDialog" :disabled="param.isview">选择文件</el-button>
                            <p>建议尺寸400*400px的JPG、PN。</p>
                        </div>
                    </el-form-item>
                    <el-form-item label="商品规格">
                        <el-input v-model="item.specs" maxlength="20" show-word-limit  :disabled="param.isview"
                                  placeholder="请输入商品规格，不超过40个字"></el-input>
                    </el-form-item>
                    <el-form-item label="划线价格">
                        <el-input v-model="item.uprice"  :disabled="param.isview"
                                  placeholder="请输入划线价格"><template slot="append">元</template></el-input>
                    </el-form-item>
                    <el-form-item label="销售价格" prop="saleprice">
                        <el-input v-model="item.saleprice" :disabled="!isAbled || param.isview"
                                  placeholder="请输入销售价格"><template slot="append">元</template></el-input>
                    </el-form-item>
                    <el-form-item label="商品库存" prop="stockcount">
                        <el-input v-model="item.stockcount" @blur="checkStockcount" :disabled="(!isAbled&&stockcount==0) || param.isview"
                                  :placeholder="stockcount==0?'不限':'请输入商品库存'"><template slot="append">个</template></el-input>
                    </el-form-item>
                    <el-form-item label="单次限购数量" prop="limitcountbyorder">
                        <el-input v-model="item.limitcountbyorder" :disabled="!isAbled || param.isview"
                                  :placeholder="limitcountbyorder==0?'不限':'请输入限购数量'"><template slot="append">个</template></el-input>
                    </el-form-item>
                    <el-form-item label="商品佣金">
                        <el-input v-model="item.brokeragerate" :disabled="!isAbled || param.isview"
                                  placeholder="输入商品佣金"><template slot="append">%</template></el-input>
                    </el-form-item>
                    <el-form-item label="商品分类">
                        <div class="label">
                            <el-select v-model="item.catecode" placeholder="选择商品分类" :disabled="!isAbled || param.isview">
                                    <el-option v-for="item in categoryList" :key="item.catecode" :label="item.catename" :value="item.catecode"></el-option>
                            </el-select>
                            <el-button type="text" @click="handleAddCate"  :disabled="param.isview">添加分类</el-button>
                        </div>
                    </el-form-item>
                    <el-form-item label="商品标签">
                        <div class="label">
                            <el-button type="primary" @click="handleAddTag" :disabled="param.isview">添加标签</el-button>
                            <div class="taglist">
                                <span class="tag selected" v-for="(obj,index) in item.taglist" :key="index" @click="handelDelTag(index)">{{obj}}<i class="icon icon_bb_del"></i></span>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="商品详情" class="haveUEditor"  prop="productdesp">
                        <uEditor :content="item.productdesp " ref="uEditor" :disabled="param.isview"
                                 @getUEditorContent="getTrySeeContent"></uEditor>
                    </el-form-item>
                </div>
            </div>
        </div>
        <el-form-item class="btnBox">
            <el-button type="primary" @click="submitForm()" :disabled="param.isview">保存</el-button>
            <el-button @click="cancel">取消</el-button>
        </el-form-item>
    </el-form>
    <ShopLocalCropper :cropperOption="cropperOption" ref="localCropper" @setImage="_setImage"
                      :uploadType="uploadType"></ShopLocalCropper>
    <tagDialog ref="tagDialog" @setTaglist="_setTaglist"></tagDialog>
    <cateDialog ref="cateDialog" @getEventProductCategoryList="_getEventProductCategoryList" @getEventProductCategoryList2="_getEventProductCategoryList2"></cateDialog>
</div>
</template>

<script>
import ShopLocalCropper from 'base/cropper/shopLocalCropper'
import {uploadEventProductInfo, getEventProductCategoryList, getEventProductInfo, uploadProductinfoByEvent,
    getProviderEventProductInfo, uploadProviderEventProductInfo, getCommonSaleProductInfo,
    getProviderCommonSaleProductInfo, uploadProviderProductinfoByEvent, getProviderEventProductCategoryList} from 'api/brandBusiness'
import UEditor from 'base/uEditor/uEditor2'
import {mapGetters, mapActions} from 'vuex'
import TagDialog from 'views/brandBusiness/systemSetting/goodsBack/components/tagDialog.vue'
import CateDialog from 'views/brandBusiness/systemSetting/goodsBack/components/cateDialog.vue'
export default {
    name: 'GoodsEdit',
    data() {
        let validateBrokeragerate = (rule, value, callback) => {
            if (parseFloat(value) > 100) {
                callback(new Error('团长佣金比例不能超过100%'))
            } else {
                callback()
            }
        }
        return {
            init: true,
            time: new Date().getTime(),
            item: {
                brokeragerate: '',
                catecode: '',
                hostroletype: 2,
                logoattid: '',
                logoatturlid: '',
                productdesp: '',
                productid: '',
                productname: '',
                rolehostid: '',
                saleprice: '',
                specs: '',
                stockcount: '',
                taglist: [],
                uprice: '',
                limitcountbyorder: '',
                specproductid: this.$route.query.specproductid ? this.$route.query.specproductid : ''
            },
            rules: {
                productname: [
                    {required: true, message: '请输入商品名称', trigger: 'blur'}
                ],
                logoatturlid: [
                    {required: true, message: '请上传商品主图', trigger: 'blur'}
                ],
                saleprice: [
                    {required: true, message: '请输入商品售价', trigger: 'blur'},
                    {pattern: /^[0-9]+(\.[0-9]{1,2})?$/, message: '请输入正确的价格（2位小数）', trigger: 'blur'}
                ],
                uprice: [
                    {pattern: /^[0-9]+(\.[0-9]{1,2})?$/, message: '请输入正确的价格（2位小数）', trigger: 'blur'}
                ],
                productdesp: [
                    {required: true, message: '请输入商品详情', trigger: 'blur'}
                ],
                stockcount: [
                    {pattern: /^[1-9]\d*|0$/, message: '请输入整数', trigger: 'blur'}
                ],
                limitcountbyorder: [
                    {pattern: /^[1-9]\d*|0$/, message: '请输入整数', trigger: 'blur'}
                ],
                brokeragerate: [
                    {pattern: /^([0-9]*)+(\.[0-9]{1,2})?$/, message: '请输入正确的推荐团长佣金(2位小数)', trigger: 'blur'},
                    {validator: validateBrokeragerate, trigger: 'blur'},
                ]
            },
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            cropperOption: {
                fixedNumber: [178, 178], // 截图框的宽高比例
                enlarge: 4.4, // 图片根据截图框输出比例倍数
                autoCropWidth: 178, // 默认生成截图框宽度
                autoCropHeight: 178 // 默认生成截图框高度
            },
            categoryList: [],
            param: {
                productid: this.$route.query.productid ? this.$route.query.productid : '',
                eventid: this.$route.query.eventid ? this.$route.query.eventid : '',
                specproductid: this.$route.query.specproductid ? this.$route.query.specproductid : '',
                iscopy: this.$route.query.iscopy ? this.$route.query.iscopy : 0,
                isview: this.$route.query.isview == 1 ? true : false
            },
            fromSource: this.$route.query.fromSource ? this.$route.query.fromSource : 1,
            eventstatus: this.$route.query.eventstatus ? this.$route.query.eventstatus : 0,
            isopenevent: this.$route.query.isopenevent ? this.$route.query.isopenevent : 0,
            isAbled: true,
            stockcount: -1,
            limitcountbyorder: 1,
            hostroletype: this.$route.query.hostroletype ? this.$route.query.hostroletype : 2 // 2 品牌商  4 服务商
        }
    },
    mounted() {
        this.item.rolehostid = this.brandBusiness.hostid
        if (this.hostroletype === 2 || this.hostroletype === '2') {
            this._getEventProductCategoryList()
        } else {
            this._getEventProductCategoryList2()
        }
    },
    methods: {
        checkStockcount() {
            if (!this.isAbled && this.stockcount > this.item.stockcount) {
                this.$message.error('活动在进行中，商品库存不能减少')
                return false
            }
            return true
        },
        handleAddCate() {
            let obj = {
                catecode: '',
                catename: ''
            }
            this.$refs.cateDialog.openDialog(obj, this.hostroletype)
        },
        handelDelTag(index) {
            this.item.taglist.splice(index, 1)
        },
        handleAddTag() {
            this.$refs.tagDialog.openDialog(this.item.taglist)
        },
        openDialog() {
            this.$refs.localCropper.openDialog()
        },
        _setImage(file) {
            this.time = new Date().getTime()
            this.item.logoattid = file.key
            this.item.logoatturlid = file.furl
        },
        _setTaglist(taglist) {
            this.item.taglist = taglist
        },
        getTrySeeContent(content) {
            this.item.productdesp = content
        },
        submitForm() {
            this.$refs.ruleForm.validate((valid, name) => {
                if (valid) {
                    let obj = this._.cloneDeep(this.item)
                    obj.taglist = obj.taglist.join(',')
                    obj.stockcount = obj.stockcount ? obj.stockcount : 0
                    obj.limitcountbyorder = obj.limitcountbyorder ? obj.limitcountbyorder : 0
                    if (this.param.iscopy == 1) {
                        obj.productid = ''
                        obj.specproductid = this.param.specproductid
                    }
                    if (this.fromSource == 1) {
                        if (this.hostroletype === 2 || this.hostroletype === '2') {
                            this._save(obj)
                        } else {
                            this._save2(obj)
                        }
                    } else {
                        if (this.checkStockcount()) {
                            if (this.hostroletype === 2 || this.hostroletype === '2') {
                                this._saveFromActivity(obj)
                            } else {
                                this._saveFromActivity2(obj)
                            }
                        }
                    }
                }
            })
        },
        cancel() {
            this.$router.back()
        },
        _save(obj) {
            this.setLoading(true)
            uploadEventProductInfo({
                data: Object.assign({}, obj),
                success: data => {
                    this.$message.success('编辑成功')
                    if (this.param.productid) {
                        this.setIsRefresh(1)
                    } else {
                        this.setIsRefresh(2)
                    }
                    this.cancel()
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _save2(obj) {
            this.setLoading(true)
            uploadProviderEventProductInfo({
                data: Object.assign({}, obj),
                success: data => {
                    this.$message.success('编辑成功')
                    if (this.param.productid) {
                        this.setIsRefresh(1)
                    } else {
                        this.setIsRefresh(2)
                    }
                    this.cancel()
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _saveFromActivity(obj) {
            this.setLoading(true)
            uploadProductinfoByEvent({
                data: Object.assign({}, obj, {eventid: this.param.eventid}),
                success: data => {
                    this.$message.success('编辑成功')
                    if (this.param.productid) {
                        this.setIsRefresh(1)
                    } else {
                        this.setIsRefresh(2)
                    }
                    this.cancel()
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _saveFromActivity2(obj) {
            this.setLoading(true)
            uploadProviderProductinfoByEvent({
                data: Object.assign({}, obj, {eventid: this.param.eventid}),
                success: data => {
                    this.$message.success('编辑成功')
                    if (this.param.productid) {
                        this.setIsRefresh(1)
                    } else {
                        this.setIsRefresh(2)
                    }
                    this.cancel()
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getEventProductCategoryList() {
            this.setLoading(true)
            getEventProductCategoryList({
                data: Object.assign({}, {
                    catename: '',
                    page: 1,
                    pageSize: 1000
                }),
                success: data => {
                    this.categoryList = data.data.content
                    this.setLoading(false)
                    if (this.param.productid) {
                        if (this.fromSource == 1) {
                            this._getView()
                        } else {
                            this._getViewFromActivity()
                        }
                    }
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        _getEventProductCategoryList2() {
            this.setLoading(true)
            getProviderEventProductCategoryList({
                data: Object.assign({}, {
                    catename: '',
                    page: 1,
                    pageSize: 1000
                }),
                success: data => {
                    this.categoryList = data.data.content
                    this.setLoading(false)
                    if (this.param.productid) {
                        if (this.fromSource == 1) {
                            this._getView()
                        } else {
                            this._getViewFromActivity2()
                        }
                    }
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        _getView() {
            this.setLoading(true)
            getEventProductInfo({
                data: Object.assign({}, this.param),
                success: data => {
                    data.data.taglist = data.data.taglist ? data.data.taglist.split(',') : []
                    data.data.brokeragerate = parseFloat(data.data.brokeragerate) ? data.data.brokeragerate : ''
                    data.data.stockcount = parseFloat(data.data.stockcount) ? data.data.stockcount : ''
                    data.data.limitcountbyorder = parseFloat(data.data.limitcountbyorder) ? data.data.limitcountbyorder : ''
                    data.data.uprice = parseFloat(data.data.uprice) ? data.data.uprice : ''
                    this.stockcount = parseFloat(data.data.stockcount) ? data.data.stockcount : 0
                    this.limitcountbyorder = parseFloat(data.data.stockcount) ? data.data.limitcountbyorder : 0
                    this.item = data.data
                    this.$nextTick(() => {
                        this.$refs.uEditor.init(this.item.productdesp)
                    })
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getView2() {
            this.setLoading(true)
            getProviderEventProductInfo({
                data: Object.assign({}, this.param),
                success: data => {
                    data.data.taglist = data.data.taglist ? data.data.taglist.split(',') : []
                    data.data.brokeragerate = parseFloat(data.data.brokeragerate) ? data.data.brokeragerate : ''
                    data.data.stockcount = parseFloat(data.data.stockcount) ? data.data.stockcount : ''
                    this.stockcount = parseFloat(data.data.stockcount) ? data.data.stockcount : 0
                    this.limitcountbyorder = parseFloat(data.data.stockcount) ? data.data.limitcountbyorder : 0
                    data.data.limitcountbyorder = parseFloat(data.data.limitcountbyorder) ? data.data.limitcountbyorder : ''
                    data.data.uprice = parseFloat(data.data.uprice) ? data.data.uprice : ''
                    this.item = data.data
                    this.$nextTick(() => {
                        this.$refs.uEditor.init(this.item.productdesp)
                    })
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getViewFromActivity() {
            this.setLoading(true)
            getCommonSaleProductInfo({
                data: Object.assign({}, this.param),
                success: data => {
                    data.data.taglist = data.data.taglist ? data.data.taglist.split(',') : []
                    this.stockcount = parseFloat(data.data.stockcount) ? data.data.stockcount : 0
                    this.limitcountbyorder = parseFloat(data.data.stockcount) ? data.data.limitcountbyorder : 0
                    data.data.stockcount = parseFloat(data.data.stockcount) ? data.data.stockcount : ''
                    data.data.limitcountbyorder = parseFloat(data.data.limitcountbyorder) ? data.data.limitcountbyorder : ''
                    data.data.uprice = parseFloat(data.data.uprice) ? data.data.uprice : ''
                    this.item = data.data
                    if (this.isopenevent == 1) {
                        this.isAbled = false
                    }
                    this.$nextTick(() => {
                        this.$refs.uEditor.init(this.item.productdesp)
                    })
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getViewFromActivity2() {
            this.setLoading(true)
            getProviderCommonSaleProductInfo({
                data: Object.assign({}, this.param),
                success: data => {
                    data.data.taglist = data.data.taglist ? data.data.taglist.split(',') : []
                    this.stockcount = parseFloat(data.data.stockcount) ? data.data.stockcount : 0
                    this.limitcountbyorder = parseFloat(data.data.stockcount) ? data.data.limitcountbyorder : 0
                    data.data.stockcount = parseFloat(data.data.stockcount) ? data.data.stockcount : ''
                    data.data.limitcountbyorder = parseFloat(data.data.limitcountbyorder) ? data.data.limitcountbyorder : ''
                    data.data.uprice = parseFloat(data.data.uprice) ? data.data.uprice : ''
                    this.item = data.data
                    // if (this.isopenevent == 1) {
                    //     this.isAbled = false
                    // }
                    this.$nextTick(() => {
                        this.$refs.uEditor.init(this.item.productdesp)
                    })
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading', 'setIsRefresh'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(['user', 'params', 'brandBusiness', 'isRefresh'])
    },
    components: {
        ShopLocalCropper, UEditor, TagDialog, CateDialog
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.GoodsEdit.form {
    margin-top: 0 !important;
}

.GoodsEdit {
    background: #F5F7FA;
    min-width: 800px;
    .label {
        display: flex;
        align-items: center;
        line-height: 1;
        .taglist{
            display: flex;
            .tag{
                background: #EEF6FF;
                color: #409EFF;
                height: 24px;
                line-height: 24px;
                padding: 0 6px;
                display: flex;
                margin-left: 20px;
                .icon{
                    &:before{
                        width: 10px;
                        height: 10px;
                        margin-left: 6px;
                    }
                }
            }
        }
    }
    .title {
        padding-bottom: 20px;
        border-bottom: 1px solid #DCDFE6;
        p {
            border-left: 2px solid #409EFF;
            text-indent: 8px;
            font-size: 14px;
            font-weight: bold;
        }
    }
    .activityMsgBox {
        background: #fff;
        padding: 20px;
        margin-bottom: 24px;

        .contentBox {
            padding-top: 20px;
            display: flex;
            justify-content: space-between;
            max-width: 1400px;
            .left {
                min-width: 500px;
                .cover, .posterImg {
                    .el-form-item__content {
                        display: flex;
                        align-items: center;
                        .imgBox {
                            width: 178px;
                            height: 178px;
                            background: #F5F7FA;
                            text-align: center;
                            line-height: 178px;
                            .el-icon-picture, .el-icon-video-camera-solid {
                                color: #DCDFE6;
                                font-size: 40px;
                            }
                            .activityCoverImage {
                                width: 178px;
                                height: 178px;
                            }
                        }
                        .uploadFileBox {
                            margin-left: 12px;
                            .uploadFile {
                                .upload-demo {
                                    .el-upload {
                                        .el-button {
                                            background: #fff;
                                            color: #000;
                                            border: 1px solid #C0C4CC;
                                        }
                                    }
                                }
                            }
                            p {
                                color: #909399;
                                font-size: 14px;
                                line-height: 20px;
                            }
                        }
                    }
                }
                .disad {
                    .el-form-item__label::after {
                        content: '*';
                        color: #F56C6C;
                        margin-left: 4px;
                    }
                }

                .el-form-item {
                    .el-form-item__content {
                        .el-input {
                            width: 420px;
                        }
                        .el-date-editor {
                            .el-input__icon, .el-range-separator {
                                line-height: 25px;
                            }
                        }
                        .mostTips {
                            color: #C0C4CC;
                        }
                        .showRankingListTips {
                            color: #909399;
                            margin-left: 20px;
                            position: relative;
                            top: 2px;
                        }
                    }
                }
            }
            .right {
                width: 300px;
                height: 534px;
                background: rgba(242, 246, 252, 1);
                box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.3);
                overflow: hidden;
                .innerBox {
                    width: 320px;
                    height: 482px;
                    overflow-y: scroll;
                }
                .home {
                    display: flex;
                    align-items: center;
                    color: #FF8142;
                    font-size: 12px;
                    height: 32px;
                    background: #fff;
                    padding-left: 12px;
                    box-sizing: border-box;
                    border-bottom: 1px solid #EBEEF5;
                    img {
                        width: 16px;
                        height: 16px;
                        margin-right: 8px;
                    }
                }
                .topBox {
                    height: 52px;
                    .top {
                        width: 300px;
                        height: 52px;
                    }
                }
                .coverImgBox {
                    background: #DCDCDC;
                    width: 300px;
                    height: 168px;
                    .activityCoverImage {
                        width: 300px;
                        height: 168px;
                    }
                }
                .priceBox {
                    height: 60px;
                    background: #fff;
                    border-bottom: 1px solid #f5f5f5;
                    padding: 7px 12px;
                    box-sizing: border-box;
                    .price {
                        color: #F56C6C;
                        margin-top: 5px;
                    }
                    .outofprint {
                        color: #909399;
                        margin-top: 10px;
                    }
                }
                .rightTitleBox {
                    background: #fff;
                    padding: 7px 12px;
                    box-sizing: border-box;
                    .rightTitle {
                        margin-top: 5px;
                        text-overflow: -o-ellipsis-lastline;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        line-clamp: 2;
                        -webkit-box-orient: vertical;
                        font-size: 16px;
                        font-weight: bold;
                        line-height: 24px;
                    }
                    .rightSubtitle {
                        color: #909399;
                        text-overflow: -o-ellipsis-lastline;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        line-clamp: 2;
                        -webkit-box-orient: vertical;
                        font-size: 12px;
                        font-weight: bold;
                        line-height: 16px;
                    }
                }
                .nameTime {
                    display: flex;
                    font-size: 12px;
                    background: #fff;
                    align-items: center;
                    padding-left: 13px;
                    // padding-bottom: 8px;
                    .name {
                        color: #576B95;
                    }
                    .time {
                        color: #909399;
                        margin-left: 14px;
                    }
                }
                .detailsBox, .articleDetailsBox {
                    margin-top: 10px;
                    .detailsTitle {
                        background: #fff;
                        padding-left: 12px;
                        height: 40px;
                        line-height: 40px;
                        border-bottom: 1px solid #f5f5f5;
                    }
                    .detailsContent {
                        background: #fff;
                        padding: 12px;
                        width: 276px;
                        overflow: hidden;
                        p {
                            width: 100%;
                            line-height: 15px;
                            text-indent: 0 !important;
                        }
                        img {
                            max-width: 100% !important;
                        }
                    }
                }
                .articleDetailsBox {
                    margin-top: 0;
                }
            }
            .rightView {
                .pasterView {
                    width: 300px;
                    height: 250px;
                    padding: 12px 13px;
                    box-sizing: border-box;
                    background: #fff;
                    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.3);
                    margin-bottom: 175px;
                    .titleText {
                        height: 30px;
                        line-height: 15px;
                        font-size: 14px;
                        text-overflow: -o-ellipsis-lastline;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        line-clamp: 2;
                        -webkit-box-orient: vertical;
                    }
                    .imgVideo {
                        margin: 10px 0;
                        height: 153px;
                        background: #DCDCDC;
                        img, video {
                            width: 100%;
                            height: 153px;
                        }
                    }
                    .desp {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        .text {
                            width: 197px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            font-size: 12px;
                        }
                        .el-button {
                            min-width: 60px;
                            height: 30px;
                            font-size: 12px;
                            min-height: 30px;
                            background: #F56C6C;
                            color: #fff;
                        }
                    }
                }
            }
        }
    }
}
</style>
